import styled, { CSSObject } from '@emotion/styled'
import React from 'react'
import { withProps } from '../../../lib/util'

interface V2L2TooltipRootProps {
	tooltip?: string
}

const V2L2TooltipRoot = styled('div', withProps([], ['tooltip']))<V2L2TooltipRootProps>(({theme, tooltip}) => {
	const tooltipAfter: CSSObject = {
		content: `"${tooltip ?? ""}"`,
		position: 'absolute',
		left: '50%',
		top: 'calc(100% + 6px)',
		transform: 'translateX(-50%)',
		whiteSpace: 'nowrap',
		background: theme.colors.black,
		color: theme.colors.white,
		padding: '6px 10px',
		borderRadius: theme.borderRadius,
		fontSize: '12px',
		opacity: 0,
		pointerEvents: 'none',
		transition: 'opacity 0.15s ease'
	}
	
	const tooltipBefore: CSSObject = {
		content: '""',
		position: 'absolute',
		left: '50%',
		top: '100%',
		transform: 'translateX(-50%)',
		border: '6px solid transparent',
		'border-top-color': theme.colors.black,
		opacity: 0,
		transition: 'opacity 0.15s ease'
	}

	return {
		position: 'relative',
		margin: 0,
		padding: 0,
		'&:after': tooltip ? {
			...tooltipAfter
		} : undefined,
		'&:before': tooltip ? {
			...tooltipBefore
		} : undefined,
		'&:hover::after': tooltip ? {
			opacity: 1
		} : undefined,
		'&:hover::before': tooltip ? {
			opacity: 1
		} : undefined
	}
})

interface V2L2TooltipProps {
	tooltip?: string
	children?: React.ReactNode
}

export const V2L2Tooltip = ({ tooltip, children }: V2L2TooltipProps) => {
	return (tooltip ? 
		<V2L2TooltipRoot tooltip={tooltip}>
			{children}
		</V2L2TooltipRoot> 
	: children)
}
